import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TherapyService } from '../therapy.service';

@Component({
  selector: 'app-eval-report',
  templateUrl: './eval-report.component.html',
  styleUrls: ['./eval-report.component.css']
})
export class EvalReportComponent implements OnInit {
  patientEvalReport: any;
  @Input('patient') patient: any;
  hasReport: boolean = true;
  isLoading = true;
  dataSourceOT: any = [];
  dataSourcePT: any = [];
  displayedColumnsDiagnosisOT = ['code','description'];
  
  constructor(private therapyService: TherapyService) { }

  async ngOnInit() {
    await this.getPatientEvalReport();

  }

  async getPatientEvalReport() {
    let patientName = this.patient.last_name + ', ' + this.patient.first_name.trim();
    this.therapyService.getPatientEvalReport(patientName).subscribe(async (res: any) => {
      if (res.status == 200  && res.data) {
        this.patientEvalReport = res.data.reports;
        await this.normalizeReport(this.patientEvalReport);
        this.hasReport = true;
        this.isLoading = false;
        this.hasReport = true;
      } else {
        this.isLoading = false;
        this.hasReport = false;
      }
    });
  }

  async normalizeReport(data) {
    for await (const report of data) {
      if(report.pt.length > 0) {
        this.dataSourcePT.push(...report.pt);  
      }
      if(report.ot.length > 0) {
        this.dataSourceOT.push(...report.ot);  
      }
    }
  }
}
